import { useEffect } from "react";
import { useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../enums/modalId";
import { RootState } from "../redux/store/store";

interface ModalOpenerConfig {
  openDeleteModal?: boolean;
  openSendToPlanModal?: boolean;
  openRerunModal?: boolean;
  openReportPrescriptionModal?: boolean;
  openReportMedicationModal?: boolean;
}

export const useModalOpener = (config?: ModalOpenerConfig) => {
  const { openedModalId } = useSelector(
    (state: RootState) => state.modalSliceNew,
  );
  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.PUSH_TO_SFTP_MODAL) {
      openModal(ModalId.PUSH_TO_SFTP_MODAL);
    }
    if (openedModalId === ModalId.SFTP_STATUS_MODAL) {
      openModal(ModalId.SFTP_STATUS_MODAL);
    }
    if (openedModalId === ModalId.SUBMISSION_SUMMARY_MODAL) {
      openModal(ModalId.SUBMISSION_SUMMARY_MODAL);
    }
    if (openedModalId === ModalId.CASE_INITIATION_MODAL) {
      openModal(ModalId.CASE_INITIATION_MODAL);
    }
    if (openedModalId === ModalId.CASE_INITIATION_UPLOAD_MODAL) {
      openModal(ModalId.CASE_INITIATION_UPLOAD_MODAL);
    }
    if (openedModalId === ModalId.PRIMARY_CARE_PDF_MODAL) {
      openModal(ModalId.PRIMARY_CARE_PDF_MODAL);
    }
    if (openedModalId === ModalId.PRIMARY_CARE_CMM_SCREENSHOT_MODAL) {
      openModal(ModalId.PRIMARY_CARE_CMM_SCREENSHOT_MODAL);
    }
    if (openedModalId === ModalId.CMM_INPUT_VIEWER_MODAL) {
      openModal(ModalId.CMM_INPUT_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.DOC_VIEWER_MODAL) {
      openModal(ModalId.DOC_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.SFTP_DOC_MODAL) {
      openModal(ModalId.SFTP_DOC_MODAL);
    }
    if (openedModalId === ModalId.TEXT_NOTE_UPLOAD) {
      openModal(ModalId.TEXT_NOTE_UPLOAD);
    }
    if (openedModalId === ModalId.TEXT_NOTE_DOC) {
      openModal(ModalId.TEXT_NOTE_DOC);
    }
    if (openedModalId === ModalId.LETTER_UPLOAD_DOC) {
      openModal(ModalId.LETTER_UPLOAD_DOC);
    }
    if (openedModalId === ModalId.SEND_TO_PLAN_CONFIRM_MODAL) {
      openModal(ModalId.SEND_TO_PLAN_CONFIRM_MODAL);
    }
    if (openedModalId === ModalId.SFTP_RERUN_MODAL) {
      openModal(ModalId.SFTP_RERUN_MODAL);
    }
    if (openedModalId === ModalId.DRUG_LABEL_MODAL) {
      openModal(ModalId.DRUG_LABEL_MODAL);
    }
    if (openedModalId === ModalId.SFTP_PUSH_PENDING_RECORDS_MODAL) {
      openModal(ModalId.SFTP_PUSH_PENDING_RECORDS_MODAL);
    }
    if (openedModalId === ModalId.ASTERA_SUBMISSION_MODAL) {
      openModal(ModalId.ASTERA_SUBMISSION_MODAL);
    }
    if (openedModalId === ModalId.ASTERA_TRACK_STATUS_MODAL) {
      openModal(ModalId.ASTERA_TRACK_STATUS_MODAL);
    }
    if (openedModalId === ModalId.RUN_DELIVERY_PIPELINE_MODAL) {
      openModal(ModalId.RUN_DELIVERY_PIPELINE_MODAL);
    }
    if (openedModalId === ModalId.EXPORT_MODAL) {
      openModal(ModalId.EXPORT_MODAL);
    }
    if (openedModalId === ModalId.CASE_INITIATION_MODAL) {
      openModal(ModalId.CASE_INITIATION_MODAL);
    }
    if (openedModalId === ModalId.CASE_INITIATION_UPLOAD_MODAL) {
      openModal(ModalId.CASE_INITIATION_UPLOAD_MODAL);
    }

    if (openedModalId === ModalId.SFTP_SUMMARY_MODAL) {
      openModal(ModalId.SFTP_SUMMARY_MODAL);
    }

    if (openedModalId === ModalId.ADD_FORM_MATRIX_DIALOG) {
      openModal(ModalId.ADD_FORM_MATRIX_DIALOG);
    }
    if (openedModalId === ModalId.ADD_NEW_LOGIC_MODAL) {
      openModal(ModalId.ADD_NEW_LOGIC_MODAL);
    }
    if (openedModalId === ModalId.ADD_NEW_CALLING_RULE_MODAL) {
      openModal(ModalId.ADD_NEW_CALLING_RULE_MODAL);
    }
    if (openedModalId === ModalId.ADD_NEW_POC_ASSIGNMENT_MODAL) {
      openModal(ModalId.ADD_NEW_POC_ASSIGNMENT_MODAL);
    }
    if (openedModalId === ModalId.UPDATE_GROUP_MODAL) {
      openModal(ModalId.UPDATE_GROUP_MODAL);
    }
    if (openedModalId === ModalId.ADD_NEW_POC_REASSIGNMENT_MODAL) {
      openModal(ModalId.ADD_NEW_POC_REASSIGNMENT_MODAL);
    }
    if (openedModalId === ModalId.CONDITION_LIST_TOP_VALUES_MODAL) {
      openModal(ModalId.CONDITION_LIST_TOP_VALUES_MODAL);
    }
    if (openedModalId === ModalId.DOWNLOAD_FILES_MODAL) {
      openModal(ModalId.DOWNLOAD_FILES_MODAL);
    }
    if (openedModalId === ModalId.PROVIDER_OPTION_FORM_MODAL) {
      openModal(ModalId.PROVIDER_OPTION_FORM_MODAL);
    }
    if (openedModalId === ModalId.DELETE_PROVIDER_OPTION_CONFIRM) {
      openModal(ModalId.DELETE_PROVIDER_OPTION_CONFIRM);
    }

    if (openedModalId === ModalId.ASTERA_PRIMARY_CARE_SUBMISSION_MODAL) {
      openModal(ModalId.ASTERA_PRIMARY_CARE_SUBMISSION_MODAL);
    }

    if (openedModalId === ModalId.PRIMARY_CARE_TRACK_STATUS_MODAL) {
      openModal(ModalId.PRIMARY_CARE_TRACK_STATUS_MODAL);
    }

    if (openedModalId === ModalId.STAT_FILE_UPLOAD_MODAL) {
      openModal(ModalId.STAT_FILE_UPLOAD_MODAL);
    }

    if (openedModalId === ModalId.ONCOLOGY_FILE_UPLOAD_MODAL) {
      openModal(ModalId.ONCOLOGY_FILE_UPLOAD_MODAL);
    }

    if (openedModalId === ModalId.REASSIGN_CASE_MODAL) {
      openModal(ModalId.REASSIGN_CASE_MODAL);
    }

    if (openedModalId === ModalId.NYCBS_EXTERNAL_LOGS_MODAL) {
      openModal(ModalId.NYCBS_EXTERNAL_LOGS_MODAL);
    }

    if (openedModalId === ModalId.NON_EPA_MODAL) {
      openModal(ModalId.NON_EPA_MODAL);
    }

    if (openedModalId === ModalId.APPEAL_INFO_MODAL) {
      openModal(ModalId.APPEAL_INFO_MODAL);
    }

    if (openedModalId === ModalId.APPEAL_SUMMARY_MODAL) {
      openModal(ModalId.APPEAL_SUMMARY_MODAL);
    }
    if (openedModalId === ModalId.DOCUMENT_MERGE_MODAL) {
      openModal(ModalId.DOCUMENT_MERGE_MODAL);
    }

    if (openedModalId === ModalId.PREDICTION_SUMMARY_MODAL) {
      openModal(ModalId.PREDICTION_SUMMARY_MODAL);
    }

    if (config) {
      if (config.openDeleteModal) {
        openModal("order-delete-confirmation");
      }
      if (config.openSendToPlanModal) {
        openModal("send-to-plan-confirm-modal");
      }
      if (config.openRerunModal) {
        openModal("rerun-confirm-modal");
      }
      if (config.openReportPrescriptionModal) {
        openModal(ModalId.REPORT_PRESCRIPTION_MODAL);
      }
      if (config.openReportMedicationModal) {
        openModal(ModalId.REPORT_MEDICATION_INACCURACY_MODAL);
      }
    }
  }, [
    openedModalId,
    config?.openDeleteModal,
    config?.openSendToPlanModal,
    config?.openRerunModal,
    config?.openReportPrescriptionModal,
    config?.openReportMedicationModal,
  ]);
  return { openedModalId };
};
